import { RouterView } from "vue-router";
import { ProfileRouting } from "./profile/profile.routing";
import { FollowRouting } from "./follow/follow.routing";
import { SolutionRouting } from "./solution/solution.routing";
import { ReconnoiterRouting } from "./reconnoiter/reconnoiter.routing";
import { ManageRouting } from "./manage/manage.routing";
import { TeamRouting } from "./team/team.routing";
import { CommissionRouting } from "./commission/commission.routing";
import { CommissionMyRouting } from "./commissionMy/commission.routing";

export const ProjectRouting = {
  path: "/project",
  name: "project",
  redirect: "/project/profile/list",
  component: RouterView,
  meta: { title: "项目管理", icon: "baobei" },
  children: [...ManageRouting,...ProfileRouting, ...FollowRouting, ...ReconnoiterRouting, ...SolutionRouting,...TeamRouting,...CommissionRouting,...CommissionMyRouting],
};
